/**
 * Created by Vladislav on 10.12.2025.
 */

const SpaceRaceWindow = Prefab.createWindow("space_race", "spaceracewindow_prefab_json");
